import { cn } from "@/lib/utils"

const statusColors = {
  active: 'bg-emerald-500',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  error: 'bg-red-500',
  inactive: 'bg-muted-foreground',
  info: 'bg-blue-500',
  program: 'bg-lime-500',
};

function StatusDot({ status = 'inactive', className }) {
  return (
    <span
      className={cn(
        "inline-block h-2 w-2 rounded-full shrink-0",
        statusColors[status] || statusColors.inactive,
        className
      )}
    />
  );
}

export { StatusDot }
